import { splitGqlUnion } from "~/shared/helpers/splitGqlUnion";

import { Shared_FormTemplate_QuestionFragment, Shared_FormTemplateFragment } from "./fragments/fragments.generated";
import { Shared_FormTemplate_QuestionConditionFragment } from "./fragments/fragmentsConditions.generated";

export function getTextValue(
    values: Record<string, string | null> | null,
    field: Shared_FormTemplate_QuestionFragment,
) {
    const value = values?.[field.key];
    if (!value) return null;
    return splitGqlUnion(field.type, {
        GqlSettingsFormTemplateQuestionTypeAmount: () => value,
        GqlSettingsFormTemplateQuestionTypeRecording: () => `${value.split(",").length}`,
        GqlSettingsFormTemplateQuestionTypeDropdown: t => t.options.find(opt => opt.key === value)?.name ?? value,
        GqlSettingsFormTemplateQuestionTypeSelect: t => t.options.find(opt => opt.key === value)?.name ?? value,
        GqlSettingsFormTemplateQuestionTypeText: () => value,
        GqlSettingsFormTemplateQuestionTypeDateTime: () => value,
    });
}

// Show fields if `deletedAt === null` OR answer exists
export function createFieldList(form: Shared_FormTemplateFragment, values: Record<string, string | null> | null) {
    return form.questions.filter(question => {
        if (!isConditionMatching(question.condition, values)) {
            return false;
        }

        return question.deletedAt === null || (values?.[question.key] !== null && values?.[question.key] !== undefined);
    });
}

export function filterNullValues(value: Record<string, string | null>): Record<string, string> {
    const result: Record<string, string> = {};

    for (const [key, val] of Object.entries(value)) {
        if (val) {
            result[key] = val;
        }
    }

    return result;
}

function isConditionMatching(
    condition: Shared_FormTemplate_QuestionConditionFragment,
    values: Record<string, string | null> | null,
): boolean {
    return splitGqlUnion(condition, {
        GqlSettingsFormTemplateQuestionConditionIsEqual: ({ fieldKey, value }) => values?.[fieldKey] === value,
        GqlSettingsFormTemplateQuestionConditionNone: () => true,
        GqlSettingsFormTemplateQuestionConditionOr: ({ conditions }) =>
            conditions.some(c => isConditionMatching(c, values)),
    });
}
